import React from "react";
import Container from "./containerUserFeedBack";
import { checkIcon } from "../Images";
import "./feedback.css";
class UserContainer extends React.Component {
  onClick = () => {
    const { data } = this.props;
    data["view"] = "resourceRatingScreen";
    return data;
  };
  render() {
    const { isMobile, logo, data } = this.props;
    console.log("props>>>>>>>>>>>>",this.props)
    return (
      <Container
        headtext="SHARE YOUR FEEDBACK"
        isMobile={isMobile}
        data={data}
        logo={logo}
        subtext="This Feedback is for the entire project, thus the rating for every resource will be same"
      >
        <div className={isMobile ? "containerSM" : "containerMD"}>
          <img src={checkIcon} className={isMobile ? "doneIconSM" : "doneIconMD"}></img>
          <h3 className={isMobile ? "thankuSM" : "thankuMD"}>
            Thank you for sharing your feedback.
          </h3>
          {data && !data.userFeedbackReceived && (
            <div>
              <div className={isMobile ? "innerThankuBoxSM" : "innerThankuBoxMD"}>
              <p className={isMobile ? "rateResourceTextSM" : "rateResourceTextMD"}>
                You have Rated {data.ratings} to every resource working in this project.
                </p>
                <p className={isMobile ? "rateResourceSubTextSM" : "rateResourceSubTextMD"}>
                  If you think that any resource has performed above or below your expectation, you can rate that
                  resource here.
                </p>
                {data.subsidiaryName === "Unthinkable Solutions LLP" || data.subsidiaryName === "Hisar-Unthinkable Solutions LLP" ? 
                 <div className={isMobile ? "rateButtonSM borderUnthinkable" : "rateButtonMD borderUnthinkable"}>
                  <div
                    className={isMobile ? "rateTextSM green" : "rateTextMD green"}
                    onClick={() => data.updateState(this.onClick())}
                  >
                    Rate Resource
                  </div>
                </div> :
                <div className={isMobile ? "rateButtonSM borderDaffodil" : "rateButtonMD borderDaffodil"}>
                  <div
                    className={isMobile ? "rateTextSM orange" : "rateTextMD orange"}
                    onClick={() => data.updateState(this.onClick())}
                  >
                    Rate Resource
                  </div>
                </div>  
               }
              </div>
            </div>
          )}
        </div>
      </Container>
    );
  }
}

export default UserContainer;
